// Delad "så filmar vi på plats"-sektion för ortssidor.
//
// Syftet är att ersätta generiska mallpåståenden om lokal närvaro med
// konkret produktionsinnehåll: var vi faktiskt filmar på orten, hur
// teamet tar sig dit och hur tillstånd hanteras. Det gör sidorna
// särskiljbara och undviker doorway-mönstret.

import { presenceFor, locationSentence } from "./presence";

export function localProductionSection(slug: string, name: string) {
  const presence = presenceFor(slug, name);
  const sites = locationSentence(presence);

  return {
    id: "pa-plats",
    heading: `Så ser en inspelningsdag i ${name} ut`,
    body: (
      <div className="space-y-4">
        <p>{presence.line}</p>
        <p>
          Vanliga inspelningsmiljöer i {name}: {sites}. Vi scoutar i förväg,
          stämmer av access, ljud och tider med er platsansvarige och söker de
          drönartillstånd som gäller för aktuella zoner innan vi flyger.
        </p>
        {presence.travelNote ? (
          <p className="text-white/70">Logistik: {presence.travelNote}.</p>
        ) : null}
      </div>
    ),
  };
}
